import { render } from "./Guiding.vue?vue&type=template&id=32c75a6d&scoped=true"
import script from "./Guiding.vue?vue&type=script&lang=js"
export * from "./Guiding.vue?vue&type=script&lang=js"

import "./Guiding.vue?vue&type=style&index=0&id=32c75a6d&lang=scss&scoped=true"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c75a6d"]])

export default __exports__